import { Button } from '@lego/connect-components-react';
import { Flex, Text } from '@lego/klik-ui';

type BulkActionsBarProps = {
  selectedItemsCount: number;
  actions: React.ReactNode;
  position: 'relative' | 'absolute';
  width?: string;
  onDeselectAll: () => void;
};

const BulkActionsBar = ({
  selectedItemsCount,
  actions,
  position,
  width = 'fit-content',
  onDeselectAll,
}: BulkActionsBarProps) => {
  return (
    <Flex
      position={position}
      bottom={'8px'}
      left={'50%'}
      transform={'translateX(-50%)'}
      backgroundColor={'black'}
      zIndex={1}
      width={width}
      borderRadius={'12px'}
      padding={'8px 40px 8px 16px'}
      justifyContent={'space-between'}
      gap={'72px'}
    >
      <Flex gap={'4px'} align={'center'}>
        <Button
          aria-label="unselect all"
          iconName="control-close-solid"
          isIconOnly
          size={'small'}
          style={{ backgroundColor: 'transparent' }}
          onClick={onDeselectAll}
        />
        <Text color="white" className={'body-sm-medium'} fontWeight={'500'}>
          {selectedItemsCount} selected
        </Text>
      </Flex>
      {actions}
    </Flex>
  );
};
export default BulkActionsBar;
